import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Return the window to the top on every route (pathname) change, so opening a
 * page from the header nav always starts at the top instead of inheriting the
 * previous page's scroll offset. The Pro shell scrolls the window itself (the
 * <main> in ProLayout is not an overflow container — header and sidebar are
 * sticky), so `window.scrollTo` is the single lever for every page.
 *
 * Skipped when the destination carries a hash, so in-page anchor targets win
 * (e.g. /clients/:id#notes, which ClientDetailPage scrolls into view). Firing
 * on the initial mount is intentional — "always land at the top" — and
 * scrollTo(0, 0) is idempotent, so no StrictMode guard is needed.
 *
 * This is route-level chrome; it does NOT replace the per-table pagination
 * anchor-scroll (those key on the page number within a single route).
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
